import { Component, inject } from "@angular/core";
import { AuthService } from "../_services/auth.service";
import { MatFabButton } from "@angular/material/button";
import { RouterLink } from "@angular/router";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    imports: [MatFabButton, RouterLink]
})
export class HomeComponent {
    private auth = inject(AuthService);
    authed = this.auth.authed;

    logout() {
        this.auth.doLogout();
    }
}
